/** Maximum distinct offline punch queue items per userKey (enqueue backpressure). */
export const OFFLINE_PUNCH_QUEUE_MAX_ITEMS = 100;
